import React, {useEffect, useRef, useState} from 'react';
import '../../../css/web/UserHome.css';
import {useLocation, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import i18n from '../../../i18n';
import axios from '../../../services/axiosInstance';
import {BsSun, BsMoonStars} from "react-icons/bs";
import {IoMenu, IoClose, IoChevronDown} from "react-icons/io5";

import {useChat} from "../../contextApi/ChatContext";
import {useWebSocket} from "../../../services/WebsocketContext";

import UserLangModal from "../modal/UserLangModal";
import useTheme from "../layoutscommon/DarkModeStorage";

/* 로고: 지시사항에 따라 btorageBooster.png 사용 */
import btorageBooster from '../../../assets/img/btorageBooster.png';
import btorageLogo from '../../../assets/img/btorageBooster.png';
import profileImage from '../../../assets/img/profileDefaultImg.png';
import selectLang from '../../../assets/img/selectLang.png';
import ordChatAlarm from '../../../assets/img/orderChatAlarm.png';
import noMessage from "../../../assets/img/noMessage.png";

/*
 * UserHeaderRenew
 * - 리뉴얼된 통합 헤더. UserHome 및 그 외 사용자 페이지(UserMainPg)에서 공용으로 사용.
 * - 기존 HeaderMain 의 기능(로그인분기, 프로필 드롭다운, 주문서채팅 알림, 웹소켓, 서브메뉴, 언어변경)을 그대로 유지.
 * - 다크/라이트: 상위에서 theme/themeToggler 를 주입하면 페이지와 테마 동기화, 미주입 시 자체 useTheme 사용.
 */
function UserHeaderRenew({theme: themeProp, themeToggler: togglerProp}) {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    // 상위 페이지가 테마를 주입하지 않으면 자체 훅으로 대체(헤더 단독 사용 대비)
    const selfTheme = useTheme();
    const theme = themeProp !== undefined ? themeProp : selfTheme[0];
    const themeToggler = togglerProp || selfTheme[1];

    const SSAT = sessionStorage.getItem('AToken');
    const LCAT = localStorage.getItem('AToken');
    const isLogin = !!(LCAT || SSAT);

    /* ---- 회원/프로필 ---- */
    const [memberDto, setMemberDto] = useState([]);
    const [profileName, setProfileName] = useState("");
    const [profilePhotoLine, setProfilePhotoLine] = useState(profileImage);

    const selectMember = () => {
        axios({method: 'get', url: '/member/modiInfo', headers: {Authorization: LCAT ? LCAT : SSAT}})
            .then((response) => {
                setMemberDto(response.data[0]);
                setProfileName(response.data[0].userName);
                if (response.data && response.data[0] && response.data[0].profileDTO && response.data[0].profileDTO.filename) {
                    setProfilePhotoLine("https://toeloperfile.s3.ap-northeast-2.amazonaws.com/profileImage/" + response.data[0].profileDTO.filename);
                } else {
                    setProfilePhotoLine(profileImage);
                }
            })
            .catch(() => console.log("실패"));
    };

    useEffect(() => {
        if (LCAT || SSAT) selectMember();
    }, [LCAT, SSAT]);

    /* ---- 채팅 알림 ---- */
    const {chatData, setChatData, totalUnreadCount, setTotalUnreadCount} = useChat();

    const getChatData = (mbNum) => {
        axios.get(`/order/chatAlarmList/${mbNum}`, {headers: {Authorization: LCAT ? LCAT : SSAT}})
            .then(response => {
                let data = response.data;
                data.sort((a, b) => b.seqnum - a.seqnum);
                setChatData(data);
                const unreadCountUpdate = data.reduce((total, chat) => total + (chat.unreadCount || 0), 0);
                setTotalUnreadCount(unreadCountUpdate);
            })
            .catch(error => console.log(error));
    };

    useEffect(() => {
        if (memberDto && memberDto.mbNum) getChatData(memberDto.mbNum);
    }, [memberDto]);

    /* ---- 웹소켓(기존 HeaderMain 동일) ---- */
    const isSubscribedRef = useRef(false);
    const {subscribe, unsubscribe, websocketConnect, isConnected, stompClient} = useWebSocket();

    useEffect(() => {
        if (!memberDto.mbNum) return;
        if (!stompClient && !isConnected) {
            websocketConnect(memberDto.mbNum).catch(err => console.error(err));
            return;
        }
        if (isConnected && stompClient && !isSubscribedRef.current) {
            subscribe(`/user/${memberDto.mbNum}/queue/adminSubMessage`, onMessageReceived);
            subscribe(`/user/${memberDto.mbNum}/queue/headerCountInit`, onChatAdminUpdate);
            subscribe(`/user/${memberDto.mbNum}/queue/adminChatUpdate`, onChatAdminUpdate);
            subscribe(`/user/${memberDto.mbNum}/queue/adminUpdateOrder`, updateOrderList);
            isSubscribedRef.current = true;
        }
        return () => {
            if (isSubscribedRef.current) {
                unsubscribe(`/user/${memberDto.mbNum}/queue/adminSubMessage`);
                unsubscribe(`/user/${memberDto.mbNum}/queue/headerCountInit`);
                unsubscribe(`/user/${memberDto.mbNum}/queue/adminChatUpdate`);
                unsubscribe(`/user/${memberDto.mbNum}/queue/adminUpdateOrder`);
                isSubscribedRef.current = false;
            }
        };
    }, [memberDto.mbNum, isConnected, stompClient]);

    const onMessageReceived = async (payload) => {
        let newMessage = JSON.parse(payload.body);
        if (Number(newMessage.mstMbNum) === Number(memberDto.mbNum)) getChatData(memberDto.mbNum);
    };
    const onChatAdminUpdate = () => getChatData(memberDto.mbNum);
    const updateOrderList = () => getChatData(memberDto.mbNum);

    /* ---- 프로필 드롭다운 ---- */
    const [dropdownSt, setDropdownSt] = useState(false);
    const dropdownRef = useRef(null);
    const toggleDropdown = () => setDropdownSt(prev => !prev);
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setDropdownSt(false);
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [dropdownRef]);

    const myOrdPgMove = (ordNum) => () => {
        setDropdownSt(false);
        navigate(`/UserMyOrderPg/${ordNum}`);
    };

    /* ---- 아바타 확대 팝업 ---- */
    const [openImagePop, setOpenImagePop] = useState(false);
    const [imageSrc, setImageSrc] = useState('');
    const openImageP = (src) => { setImageSrc(src); setOpenImagePop(true); };
    const closeImageP = () => { setOpenImagePop(false); setImageSrc(''); };

    /* ---- 쿠폰 ---- */
    const [dbCoupon, setDbCoupon] = useState('');
    useEffect(() => {
        const activeCouponCount = memberDto && memberDto.coupons && memberDto.coupons.filter(c => c && c.activeFl === true).length;
        setDbCoupon(activeCouponCount || 0);
    }, [memberDto]);

    /* ---- 로그아웃 ---- */
    const logout = () => axios({method: 'post', url: '/member/logout', headers: {Authorization: LCAT ? LCAT : SSAT}})
        .then(() => {
            if (SSAT) { sessionStorage.removeItem('AToken'); sessionStorage.removeItem('lastLoginTime'); }
            else { localStorage.removeItem('AToken'); localStorage.removeItem('lastLoginTime'); }
            sessionStorage.setItem("redirectAfterLogin", location.pathname);
            navigate("/UserLoginPg");
        })
        .catch(() => {
            if (SSAT) { sessionStorage.removeItem('AToken'); sessionStorage.removeItem('lastLoginTime'); }
            else { localStorage.removeItem('AToken'); localStorage.removeItem('lastLoginTime'); }
            navigate("/UserLoginPg");
        });

    const convertToLastChatDate = (regDate) => {
        const regTime = new Date(regDate);
        const currentTime = new Date();
        const minutesDiff = Math.floor((currentTime - regTime) / 60000);
        const hoursDiff = Math.floor(minutesDiff / 60);
        const daysDiff = Math.floor(hoursDiff / 24);
        if (daysDiff < 1) {
            if (minutesDiff < 1) return t('now');
            if (minutesDiff < 60) return `${minutesDiff}${t('min')}`;
            return `${hoursDiff}${t('hour')}`;
        } else if (daysDiff === 1) return t('yesterday');
        else if (daysDiff === 2) return t('2daysAgo');
        else if (daysDiff < 7) return `${daysDiff}${t('daysAgo')}`;
        return `${(regTime.getMonth() + 1).toString().padStart(2, '0')}-${regTime.getDate().toString().padStart(2, '0')}`;
    };

    /* ---- 네비게이션 / 서브메뉴 ---- */
    const [serviceMenu, setServiceMenu] = useState(false);
    const [orderMenu, setOrderMenu] = useState(false);
    const closeSubMenus = () => { setServiceMenu(false); setOrderMenu(false); };

    // 모바일 햄버거 메뉴
    const [mobileNavOpen, setMobileNavOpen] = useState(false);
    const closeMobileNav = () => setMobileNavOpen(false);
    const mnav = (fn) => () => { closeMobileNav(); fn(); };

    // [구매대행 API] 상점사 화면은 비토리지 고객화면과 세션/화면이 분리되어 있으므로 새창으로 띄운다.
    const openStoreDashboard = () => window.open("/store/api/dashboard", "_blank", "noopener,noreferrer");

    const handleMenuCart = () => navigate("/UserOrderPg", {state: {cartState: true, headerText: t("hdMenu2")}});
    const handleMenuOrder = () => navigate("/UserOrderPg", {state: {orderState: true, headerText: t("hdSMenu6")}});
    const handleMenuOffline = () => navigate("/UserOrderPg", {state: {offlineState: true, headerText: t("hdSMenu8")}});
    const handleMenuTransfer = () => navigate("/UserOrderPg", {state: {transferState: true, headerText: t("hdSMenu7")}});
    const handleMenuDomestic = () => navigate("/UserOrderPg", {state: {domesticState: true, headerText: t("hdSMenu9")}});
    const handleMenuDelivery = () => navigate("/UserOrderPg", {state: {deliveryState: true, headerText: t("hdMenu4")}});

    const toggleService = () => { setServiceMenu(prev => !prev); setOrderMenu(false); };
    const toggleOrder = () => { setOrderMenu(prev => !prev); setServiceMenu(false); };

    const mainRefresh = () => { window.location.href = "/"; };

    /* ---- 언어 변경 ---- */
    const [selectLangSt, setSelectLangSt] = useState(false);
    const selectLangFalseFn = () => setSelectLangSt(false);
    const handleSelectLangChange = (lang) => {
        setSelectLangSt(false);
        i18n.changeLanguage(lang);
        localStorage.setItem('lang', lang);
    };

    return (
        <div className="uh-header-scope" data-theme={theme}>
            <header className="uh-header">
                <div className="uh-header-inner">
                    <img className="uh-logo" src={btorageBooster} alt="Btorage" onClick={mainRefresh}/>

                    <nav className="uh-nav">
                        <button className={`uh-nav-item ${serviceMenu ? "is-active" : ""}`} onClick={toggleService}>{t("hdMenu1")}</button>
                        <button className="uh-nav-item" onClick={handleMenuCart}>{t("hdMenu2")}</button>
                        <button className={`uh-nav-item ${orderMenu ? "is-active" : ""}`} onClick={toggleOrder}>{t("hdMenu3")}</button>
                        <button className="uh-nav-item" onClick={handleMenuDelivery}>{t("hdMenu4")}</button>
                        <button className="uh-nav-item" onClick={() => navigate("/UserReviewPg")}>{t("hdMenu5")}</button>
                        {/* [구매대행 API] 쇼핑몰(상점사) 전용 진입메뉴 */}
                        <button className="uh-nav-item" onClick={openStoreDashboard}>{t("hdMenu6")}</button>
                    </nav>

                    <div className="uh-actions">
                        <button className="uh-icon-btn" onClick={themeToggler} aria-label="theme" title={theme === 'dark' ? 'Light' : 'Dark'}>
                            {theme === 'dark' ? <BsSun/> : <BsMoonStars/>}
                        </button>
                        <button className="uh-icon-btn" onClick={() => setSelectLangSt(true)} aria-label="language" title="Language">
                            <img src={selectLang} alt="lang"/>
                        </button>
                        {/* 모바일 햄버거: 좁은 화면에서 상/하위 메뉴 진입 */}
                        <button className="uh-icon-btn uh-hamburger" onClick={() => setMobileNavOpen(true)} aria-label="menu" title="Menu">
                            <IoMenu/>
                        </button>

                        {isLogin ?
                            <>
                                <button className="uh-btn uh-btn-ghost" onClick={() => navigate("/UserMyPg")}>{t("hdMypg")}</button>
                                <div className="uh-profile" ref={dropdownRef}>
                                    <img className="uh-avatar" src={profilePhotoLine} alt="profile" onClick={toggleDropdown}/>
                                    {totalUnreadCount > 0 && <span className="uh-avatar-badge">{totalUnreadCount}</span>}

                                    {dropdownSt &&
                                        <div className="uh-dropdown">
                                            <div className="uh-dd-profile">
                                                <img className="uh-dd-avatar" src={profilePhotoLine} alt="" onClick={() => openImageP(profilePhotoLine)}/>
                                                <p className="uh-dd-name">{profileName}</p>
                                            </div>
                                            <div className="uh-dd-stats">
                                                <div className="uh-dd-stat"><span>{t("myOrdPc1")}</span><b>BT {memberDto.mbNum}</b></div>
                                                <div className="uh-dd-stat"><span>{t("myOrdPc2")}</span><b>&#8361; {(memberDto && memberDto?.deposit?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')) || 0}</b></div>
                                                <div className="uh-dd-stat"><span>{t("myOrdPc3")}</span><b>&#8361; {(memberDto && memberDto?.point?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')) || 0}</b></div>
                                                <div className="uh-dd-stat"><span>My{t("modSHeader13")}</span><b>{dbCoupon && dbCoupon > 0 ? dbCoupon : 0}</b></div>
                                            </div>
                                            <div className="uh-dd-sep"/>
                                            <div className="uh-dd-chat-title">
                                                <img src={ordChatAlarm} alt="chat"/>
                                                <span>{t("hdChat")}</span>
                                            </div>
                                            {chatData && chatData[0] ?
                                                chatData.slice(0, 6).map((data, index) => (
                                                    data.unreadCount > 0 &&
                                                    <div key={index} className="uh-dd-chat-row" onClick={myOrdPgMove(data.chatOrdNum)}>
                                                        <span className="uh-dd-chat-unread">{data.unreadCount}</span>
                                                        <img className="uh-dd-chat-thumb" alt=""
                                                             src={data.memberDTO && data.memberDTO.profileDTO && data.memberDTO.profileDTO.filename ?
                                                                 "https://toeloperfile.s3.ap-northeast-2.amazonaws.com/profileImage/" + data.memberDTO.profileDTO.filename : btorageLogo}/>
                                                        <div className="uh-dd-chat-meta">
                                                            <div className="t">
                                                                <span>{data.chatOrdNum}</span>
                                                                <span style={{color: "var(--uh-text-faint)", fontSize: 11}}>{convertToLastChatDate(data.regTime)}</span>
                                                            </div>
                                                            <div className="c">{data.chatKey.startsWith("chatFile") ? data.fileNm : data.chatKey}</div>
                                                        </div>
                                                    </div>
                                                ))
                                                :
                                                <div className="uh-dd-nochat">
                                                    <img src={noMessage} alt="no"/>
                                                    <p>No Message</p>
                                                </div>
                                            }
                                            <div className="uh-dd-actions">
                                                <button className="uh-btn uh-btn-ghost" onClick={() => navigate("/UserModiPg")}>{t("hdBt1")}</button>
                                                <button className="uh-btn uh-btn-ghost" onClick={logout}>{t("hdBt2")}</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </>
                            :
                            <button className="uh-btn uh-btn-primary" onClick={() => navigate("/UserLoginPg")}>{t("hdLogin")}</button>
                        }
                    </div>
                </div>

                {(serviceMenu || orderMenu) &&
                    <div className="uh-submenu">
                        <div className="uh-submenu-inner">
                            {serviceMenu &&
                                <>
                                    <span className="uh-submenu-link" onClick={() => { closeSubMenus(); navigate('/UserUsageGuidePg'); }}>{t("hdSMenu2")}</span>
                                    <span className="uh-submenu-link" onClick={() => { closeSubMenus(); navigate('/UserCustomInfoPg'); }}>{t("hdSMenu3")}</span>
                                    <span className="uh-submenu-link" onClick={() => { closeSubMenus(); navigate('/UserCompareShipPg'); }}>{t("hdSMenu4")}</span>
                                    <span className="uh-submenu-link" onClick={() => { closeSubMenus(); navigate('/UserDepChargePg'); }}>{t("hdSMenu5")}</span>
                                    <span className="uh-submenu-link" onClick={() => { closeSubMenus(); navigate('/UserPickupRequestPg'); }}>{t("smPickupBt")}</span>
                                </>
                            }
                            {orderMenu &&
                                <>
                                    <span className="uh-submenu-link" onClick={() => { closeSubMenus(); handleMenuOrder(); }}>{t("hdSMenu6")}</span>
                                    <span className="uh-submenu-link" onClick={() => { closeSubMenus(); handleMenuTransfer(); }}>{t("hdSMenu7")}</span>
                                    <span className="uh-submenu-link" onClick={() => { closeSubMenus(); handleMenuOffline(); }}>{t("hdSMenu8")}</span>
                                    <span className="uh-submenu-link" onClick={() => { closeSubMenus(); handleMenuDomestic(); }}>{t("hdSMenu9")}</span>
                                </>
                            }
                        </div>
                    </div>
                }
            </header>

            {/* 모바일 메뉴 드로어 (상위/하위 메뉴 진입) */}
            {mobileNavOpen &&
                <div className="uh-mnav-overlay" onClick={closeMobileNav}>
                    <div className="uh-mnav" onClick={(e) => e.stopPropagation()}>
                        <div className="uh-mnav-head">
                            <span>MENU</span>
                            <button className="uh-mnav-close" onClick={closeMobileNav} aria-label="close"><IoClose/></button>
                        </div>
                        <div className="uh-mnav-body">
                            {/* 서비스 */}
                            <div className="uh-mnav-group-title"><IoChevronDown/>{t("hdMenu1")}</div>
                            <span className="uh-mnav-sub" onClick={mnav(() => navigate('/UserUsageGuidePg'))}>{t("hdSMenu2")}</span>
                            <span className="uh-mnav-sub" onClick={mnav(() => navigate('/UserCustomInfoPg'))}>{t("hdSMenu3")}</span>
                            <span className="uh-mnav-sub" onClick={mnav(() => navigate('/UserCompareShipPg'))}>{t("hdSMenu4")}</span>
                            <span className="uh-mnav-sub" onClick={mnav(() => navigate('/UserDepChargePg'))}>{t("hdSMenu5")}</span>
                            <span className="uh-mnav-sub" onClick={mnav(() => navigate('/UserPickupRequestPg'))}>{t("smPickupBt")}</span>

                            {/* 장바구니 */}
                            <div className="uh-mnav-item" onClick={mnav(handleMenuCart)}>{t("hdMenu2")}</div>

                            {/* 구매대행 */}
                            <div className="uh-mnav-group-title"><IoChevronDown/>{t("hdMenu3")}</div>
                            <span className="uh-mnav-sub" onClick={mnav(handleMenuOrder)}>{t("hdSMenu6")}</span>
                            <span className="uh-mnav-sub" onClick={mnav(handleMenuTransfer)}>{t("hdSMenu7")}</span>
                            <span className="uh-mnav-sub" onClick={mnav(handleMenuOffline)}>{t("hdSMenu8")}</span>
                            <span className="uh-mnav-sub" onClick={mnav(handleMenuDomestic)}>{t("hdSMenu9")}</span>

                            {/* 배송대행 / 이용후기 */}
                            <div className="uh-mnav-item" onClick={mnav(handleMenuDelivery)}>{t("hdMenu4")}</div>
                            <div className="uh-mnav-item" onClick={mnav(() => navigate("/UserReviewPg"))}>{t("hdMenu5")}</div>
                            {/* [구매대행 API] 쇼핑몰(상점사) 전용 진입메뉴 */}
                            <div className="uh-mnav-item" onClick={mnav(openStoreDashboard)}>{t("hdMenu6")}</div>
                        </div>
                    </div>
                </div>
            }

            {selectLangSt &&
                <UserLangModal theme={theme} selectLangFalseFn={selectLangFalseFn} handleSelectLangChange={handleSelectLangChange}/>}

            {openImagePop &&
                <div className="uh-imgpop" onClick={closeImageP}>
                    <div className="uh-imgpop-frame" onClick={(e) => e.stopPropagation()}>
                        <img src={imageSrc} alt="profile"/>
                        <button className="uh-imgpop-close" onClick={closeImageP}>×</button>
                    </div>
                </div>
            }
        </div>
    );
}

export default UserHeaderRenew;
